import React from 'react'
import { zodResolver } from "@hookform/resolvers/zod";
import { Button, Input, Separator } from "@postcheesy/ui-lib/atoms";
import {
    Form,
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from "@postcheesy/ui-lib/molecules";
import { Link } from "react-router-dom";

import { useForm } from "react-hook-form";
import { z } from "zod";

import { registerSchema } from "../../../resources/schema/register-schema";

import register from "../../../api/register";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../resources/constants/routes";
import { EyeIcon, EyeOffIcon, FacebookIcon } from 'lucide-react';
import login from '../../../api/login';

export const FormRegister: React.FC = () => {
    const schema = registerSchema;

    const naviguate = useNavigate();
    const [showPassword, setShowPassword] = React.useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
    const [error, setError] = React.useState<string | null>(null);

    const form = useForm<z.infer<typeof schema>>({
        resolver: zodResolver(schema),
        mode: "onBlur",
    });

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const { email, password } = form.getValues();
        const result = await register(email, password);

        if (result === true) {
            setError(null);
            const loginResult = await login(email, password);

            if (loginResult.success) {
                setError(null);
                naviguate(ROUTES.CONFIRM_EMAIL);
            } else {
                setError(loginResult.message ?? null);
            }

            naviguate(ROUTES.CONFIRM_EMAIL);
        } else {
            setError(result);
        }
    };
    return (
        <Form {...form}>
            <form className="space-y-2" onSubmit={handleSubmit}>
                <FormField
                    control={form.control}
                    name="email"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel>Email</FormLabel>
                            <FormControl>
                                <Input
                                    id="email"
                                    type="email"
                                    autoComplete={"off"}
                                    placeholder="email@example.com"
                                    {...field}
                                />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="password"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel>Mot de passe</FormLabel>
                            <FormControl>
                                <div className='flex items-center'>
                                    <Input id="password" type={showPassword ? "text" : "password"} autoComplete={"off"} {...field} placeholder="Mot de passe" />
                                    <Button
                                        type="button"
                                        className='h-9'
                                        onClick={() => setShowPassword(!showPassword)}
                                    >
                                        {showPassword ? <EyeIcon className="w-4 h-4" /> : <EyeOffIcon className="w-4 h-4" />}
                                    </Button>
                                </div>

                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="confirmPassword"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel>Confirmer le mot de passe</FormLabel>
                            <FormControl>
                                <div className='flex items-center'>
                                    <Input id="confirmPassword" type={showConfirmPassword ? "text" : "password"} autoComplete="off" placeholder="Confirmer mot de passe" {...field} />
                                    <Button
                                        type="button"
                                        className='h-9'
                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    >
                                        {showConfirmPassword ? <EyeIcon className="w-4 h-4" /> : <EyeOffIcon className="w-4 h-4" />}
                                    </Button>
                                </div>
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />
                {error && (
                    <div className="text-red-500 text-sm mt-2">
                        {error}
                    </div>
                )}
                <div className="grid w-full gap-2">
                    <Button type="submit">S'enregistrer</Button>

                    <div className="px-4 py-3">
                        <Separator />
                    </div>
                    <div className="mt-4 text-center text-sm">
                        Vous avez déjà un compte?{" "}
                        <Link to={"/login"} className="underline">
                            Connectez-vous
                        </Link>
                    </div>
                </div>
            </form>
        </Form>
    )
}
